import React from 'react'
import { useAdminContext } from '../../context/admin-context'
import { usePropertyWeeks } from './use-property-weeks';

import './rental-property-bookings.css'

export default function RentalPropertyBookings({
  propertyId,
  startWeek,
  endWeek,
}) {

  const {
    reservationsData,
    // activeWeek,
    // activeBooking
  } = useAdminContext();

  const { isLoading, isError } = reservationsData;

  const weeks = usePropertyWeeks({propertyId, startWeek, endWeek});

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (isError) {
    return <div>Something went wrong...</div>
  }

  return (
    <div className="rental_property_bookings">
      {weeks.map((week) => (week))}
    </div>
  )
}
